var path = 'common/components/modal-confirm/modal-confirm.html';
var html = "<div id=\"modal-confirm\">\n    <div class=\"modal-body\" id=\"modal-body\">\n        <p class=\"modal-body-message\" ng-bind-html=\"$modalConfirmCtrl.message\"></p>\n        <button type=\"button\" ng-click=\"$modalConfirmCtrl.cancel()\">Cancel</button>\n        <button ng-class=\"$modalConfirmCtrl.buttonClass\" type=\"button\" ng-click=\"$modalConfirmCtrl.ok()\">{{$modalConfirmCtrl.buttonText}}</button>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./common/components/modal-confirm/modal-confirm.html
// module id = ./common/components/modal-confirm/modal-confirm.html
// module chunks = 0